import angular from 'angular';

export default angular.module('shared').constant('doughnutColorConstants', {
    blue: '#087ACA',
    grey: '#708a9b',
    yellow: '#F8BD5F',
    red: '#F11E1E'
});



// WEBPACK FOOTER //
// ./modules/shared/constants/doughnutColor.constant.js